import React from 'react';

const Role = () => {
  return (
    <div className="border border-gray-200 rounded-3xl p-8 mt-1 text-left bg-gradient-to-r to-indigo-400 from-purple-500 text-white">
      
      {/* Subheadline */}
      <h2 className="text-7xl font-light mb-4">
        Automated A/B testing  <br /> & data-driven decision-making <br />to optimize your platform experiences in real-time.
      </h2>
      
      {/* Description */}
      <p className="text-2xl text-white mb-6">
        Our platform dynamically tests and analyzes UI components using cutting-edge AI to maximize engagement, conversions, and user satisfaction. 
      </p>
    </div>
  );
};

export default Role; 